import React, { forwardRef, useImperativeHandle, useState } from "react";

import { Typography } from "antd";
import { CheckOutlined, CloseOutlined, CloudOutlined, CloudSyncOutlined, LoadingOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
const { Text } = Typography;

export const SaveState = Object.freeze({
	EMPTY: "",
	TO_SAVE: "to-save",
	SAVING: "saving",
	SAVED: "saved",
	ERROR: "error",
});

export const SaveStateTransactions = forwardRef(({children}, ref) => {
	const [state, setState] = useState(SaveState.EMPTY);
	
	useImperativeHandle(ref, () => ({
		changeState: (state) => setState(state),
	}));
	
	return (
		<>			
			{state === SaveState.EMPTY && <CloudOutlined />}
			{state === SaveState.TO_SAVE && <Text><CloudSyncOutlined /> Se subirán los cambios...</Text>}
			{state === SaveState.SAVING && <Text><LoadingOutlined /> Guardando...</Text>}
			{state === SaveState.SAVED && <Text><CheckOutlined />Guardado en ARO</Text>}
			{state === SaveState.ERROR && <Text><CloseOutlined /> Ocurrion un error</Text>}
			{children}
		</>
	);
});

SaveStateTransactions.displayName = "SaveStateTransactions";

SaveStateTransactions.propTypes = {
	children: PropTypes.node,
};